import { AxiosInstance } from "axios";
import {
  ChatHistoryResponse,
  ChatPostRequest,
  ChatPostResponse,
} from "../types/aiCoach";
import { getApiClient } from "../utils/api.utils";

export class AICoachService {
  client: AxiosInstance;

  constructor() {
    this.client = getApiClient();
  }

  /** Fetch any existing chat history for this learner + touchpoint. */
  getChat = async (
    learnerId: string,
    touchpointId: string
  ): Promise<ChatHistoryResponse> => {
    const response = await this.client.get<ChatHistoryResponse>(
      `/training/learners/${learnerId}/touchpoints/${touchpointId}/chat/`
    );
    return response.data;
  };

  /** Post a new question; server returns the full updated conversation. */
  postQuestion = async (
    learnerId: string,
    touchpointId: string,
    body: ChatPostRequest
  ): Promise<ChatPostResponse> => {
    const response = await this.client.post<ChatPostResponse>(
      `/training/learners/${learnerId}/touchpoints/${touchpointId}/chat/`,
      body
    );
    return response.data;
  };
}
